import { createFileRoute, redirect } from '@tanstack/react-router';
import { OnboardingPage } from '@/components/onboarding';
import { getToken } from '@/lib/session';

/** Onboarding (modo simples): tela cheia, fora do AppShell (como no design), protegida por JWT. */
export const Route = createFileRoute('/comecar')({
  beforeLoad: () => {
    if (!getToken()) throw redirect({ to: '/login' });
  },
  component: OnboardingPage,
});
